/** Poll until CTM (loaded via GTM) is ready, then swap numbers. */
export function runCtmWhenReady() {
  if (typeof window === 'undefined') {
    return;
  }

  const maxAttempts = 40;
  let attempts = 0;

  const tick = () => {
    attempts += 1;
    if (window.__ctm?.main?.runNow) {
      window.__ctm.main.runNow();
      return;
    }
    if (attempts < maxAttempts) {
      setTimeout(tick, 250);
    }
  };

  tick();
}
